import { blockCategories } from '../../categories';

const COMPONENT_TYPE = 'intent-block-component';

export default function intentBlock(editor, opts = {}) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    domComponents.addType(COMPONENT_TYPE, {
        isComponent: (el) =>
            el.tagName === 'DIV' && el.classList?.contains('sio-intent-block'),

        model: {
            defaults: {
                'custom-name': 'Intent',
                tagName: 'div',
                droppable: true,
                draggable: true,
                stylable: true,
                editable: true,

                attributes: {
                    class: 'sio-intent-block',
                    'data-siotype': COMPONENT_TYPE,
                    'data-field-label': 'Intent',
                },

                style: {
                    display: 'inline-block',
                    'max-width': '100%',
                    padding: '12px',
                },

                traits: [
                    {
                        type: 'number',
                        name: 'mouseLeaveDelay',
                        label: 'Mouse Leave Delay (ms)',
                        default: 1000,
                        changeProp: 1,
                    },
                    {
                        type: 'number',
                        name: 'idleTime',
                        label: 'Idle Time (ms)',
                        default: 8000,
                        changeProp: 1,
                    },
                    {
                        type: 'number',
                        name: 'timeOnPage',
                        label: 'Time on Page (ms)',
                        default: 15000,
                        changeProp: 1,
                    },
                    {
                        type: 'number',
                        name: 'mobileBreakpoint',
                        label: 'Mobile Break Point (px)',
                        default: 768,
                        changeProp: 1,
                    },
                    {
                        type: 'number',
                        name: 'scrollUpInterval',
                        label: 'Scroll Up Interval (px)',
                        default: 768,
                        changeProp: 1,
                    },
                ],
                components: [
                    {
                        type: 'text',
                        content: 'Intent Block',
                        editable: true,
                    },
                ],
            },

            init() {
                this.on('change:mouseLeaveDelay', this.syncAttrs);
                this.on('change:idleTime', this.syncAttrs);
                this.on('change:timeOnPage', this.syncAttrs);
                this.on('change:mobileBreakpoint', this.syncAttrs);
                this.on('change:scrollUpInterval', this.syncAttrs);
            },

            syncAttrs() {
                this.set('attributes', {
                    ...this.get('attributes'),
                    'data-mouse-leave-delay': this.get('mouseLeaveDelay'),
                    'data-mobile-idle-time': this.get('idleTime'),
                    'data-time-on-page': this.get('timeOnPage'),
                    'data-mobile-breakpoint': this.get('mobileBreakpoint'),
                    'data-scrollUp-interval': this.get('scrollUpInterval'),

                });
            },
        },

        view: {},
    });

    blockManager.add(COMPONENT_TYPE, {
        label: 'Intent',
        category: blockCategories.advance,

        media: `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"
            fill="none"
            stroke="currentColor"
            >
            <path d="M424.5 355.1C449 329.2 464 294.4 464 256C464 176.5 399.5 112 320 112C240.5 112 176 176.5 176 256C176 294.4 191 329.2 215.5 355.1C236.8 377.5 260.4 409.1 268.8 448L371.2 448C379.6 409 403.2 377.5 424.5 355.1zM459.3 388.1C435.7 413 416 443.4 416 477.7L416 496C416 540.2 380.2 576 336 576L304 576C259.8 576 224 540.2 224 496L224 477.7C224 443.4 204.3 413 180.7 388.1C148 353.7 128 307.2 128 256C128 150 214 64 320 64C426 64 512 150 512 256C512 307.2 492 353.7 459.3 388.1zM272 248C272 261.3 261.3 272 248 272C234.7 272 224 261.3 224 248C224 199.4 263.4 160 312 160C325.3 160 336 170.7 336 184C336 197.3 325.3 208 312 208C289.9 208 272 225.9 272 248z"/></svg>
        `,

        content: {
            type: COMPONENT_TYPE,
        },
    });
}
